import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { EMPTY_ORG_COMPENSATIONS, parseOrgCompensations, type OrgCompensations } from "@/lib/compensation-usage";

export function useOrgCompensations(orgId: string | null, enabled: boolean) {
  const [result, setResult] = useState<{ orgId: string; data: OrgCompensations; error: boolean } | null>(null);

  useEffect(() => {
    if (!orgId || !enabled) return;
    let cancelled = false;
    Promise.resolve(supabase.rpc("my_conversation_compensations" as never, { p_org_id: orgId } as never)).then(({ data, error }) => {
      if (cancelled) return;
      if (error) console.error("[useOrgCompensations]", error.message);
      setResult({ orgId, data: error ? EMPTY_ORG_COMPENSATIONS : parseOrgCompensations(data), error: !!error });
    });
    return () => { cancelled = true; };
  }, [orgId, enabled]);

  const loaded = enabled && !!orgId && result?.orgId === orgId;
  return {
    data: loaded ? result.data : null,
    error: loaded ? result.error : false,
    loading: enabled && !!orgId && !loaded,
  };
}
